var map = {
	"./icon0.svg": "450e",
	"./icon1.svg": "e2c7",
	"./icon2.svg": "06f2",
	"./icon3.svg": "a29b",
	"./icon4.svg": "d52f",
	"./icon5.svg": "2dca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cd0";